export default __webpack_public_path__ + "static/media/small.d27caf79.jpg";